module.exports = __webpack_public_path__ + "static/img/7.f51dd93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news14/7.png
// module id = rjce
// module chunks = 1